import type { ReactNode } from "react";
import { Code } from "lucide-react";
import {
  LiftTabsGroup,
  type LiftTabItem,
} from "@/components/molecules/liftTabsGroup";
import { RTE_LIFT_TABS_CONTENT_BORDER_CLASS } from "../../richTextEditorLayout";

const MODE_TABS: LiftTabItem<string>[] = [
  {
    value: "markdown",
    label: "Markdown",
    content: <Code className="size-4" />,
  },
  { value: "wysiwyg", label: "WYSIWYG", content: "WYSIWYG" },
];

export interface RichTextEditorFooterProps {
  value: string;
  onValueChange: (value: string) => void;
  children: ReactNode;
  ariaLabel?: string;
}

export const RichTextEditorFooter = ({
  value,
  onValueChange,
  children,
  ariaLabel = "Editor mode",
}: RichTextEditorFooterProps) => (
  <LiftTabsGroup
    items={MODE_TABS}
    value={value}
    onValueChange={onValueChange}
    childrenWrapperStyle={[RTE_LIFT_TABS_CONTENT_BORDER_CLASS]}
    ariaLabel={ariaLabel}
  >
    {children}
  </LiftTabsGroup>
);
